<div class="card shadow-sm border-0">
  <nz-skeleton [ngClass]="loading ? 'p-3' : 'p-0'" [nzLoading]="loading" [nzActive]="true">
    <div class="p-4">
      <div class="d-flex align-items-center gap-1 mb-2">
        <span class="card-title mb-0">Balance</span>
        <i class="icon-info-circle"
          placement="top left"
          ngbPopover="Your current balance"
          triggers="mouseenter:mouseleave"></i>
      </div>
      <h2 class="nominal mb-0 text-truncate">
        {{ balance.balance | currency : "IDR" : "symbol" : "1.0-0" }}
      </h2>
    </div>

    <div class="bg-footer-card p-2 d-flex align-items-center justify-content-around gap-2">
      <!-- Top Up Button -->
      <button class="btn btn-link text-white text-decoration-none d-flex flex-column flex-md-row align-items-center gap-1 gap-md-2 p-2"
        [disabled]="isSandBoxMode"
        (click)="handleTopUp()">
        <i class="icon icon-send-square"></i>
        <span class="text-card-button d-none d-sm-block">Top Up</span>
      </button>

      <!-- Withdrawal Button -->
      <button class="btn btn-link text-white text-decoration-none d-flex flex-column flex-md-row align-items-center gap-1 gap-md-2 p-2"
        [disabled]="isWithdrawalDisabled()"
        (click)="handleWithdrawal()">
        <i class="icon icon-receive-square"></i>
        <span class="text-card-button d-none d-sm-block">Withdrawal</span>
      </button>

      <!-- Detail Link -->
      <a [routerLink]="['/finance/balance/detail']"
        class="text-white text-decoration-none d-flex flex-column flex-md-row align-items-center gap-1 gap-md-2 p-2">
        <i class="icon icon-document-text"></i>
        <span class="text-card-button d-none d-sm-block">Detail</span>
      </a>
    </div>
  </nz-skeleton>
</div>
